import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnResizeBar from "@shared/components/SnResizeBar";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import { menuInfo } from "@shared/type/CommonType";

interface Props {
  Menuprops: menuInfo;
}

// 2단그리드
const MENU_ID = "SN_MTL_QIO_REP_006"; // 메뉴코드
const SEARCH_QUERY_ID = "sn_mtl_qio_rep_008_01"; // 조회쿼리
const LINK_COLUMNS = ["cd_item"]; // 메뉴 메인컬럼 ex) 수주등록 no_so, 발주등록 no_po

const SN_MTL_QIO_REP_006 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region variable
  const { userInfo } = global();
  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });
  //#endregion

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({
          menuInfo: Menuprops || ({ cd_menu: MENU_ID } as menuInfo),
          etcInfo: {},
        });

        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error: any) {}
    };

    fetchform();
  }, [Menuprops]);

  //#region Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  const onSearch = async () => {
    try {
      const params = {
        id: SEARCH_QUERY_ID,
        params: searchRef.current.getFormdata(),
      };

      getGridCurrent("grid1").resetUpdate();
      getGridCurrent("grid2").resetUpdate();

      const data: any = await fnGetDataSet(params);
      setDataSources((prev: any) => ({
        ...prev,
        grid1: data[0] || [],
      }));
    } catch (error: any) {}
  };
  //#endregion

  //#region Grid Event

  const onFocusedRowChanged = async (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const cd_item = selectedRow.cd_item;

      try {
        const params = {
          id: "sn_mtl_qio_rep_008_02",
          params: {
            ...searchRef.current.getFormdata(),
            cd_item,
          },
        };

        getGridCurrent("grid1").resetUpdate();
        getGridCurrent("grid2").resetUpdate();

        const data: any = await fnGetDataSet(params);
        setDataSources((prev: any) => ({
          ...prev,
          grid2: data[0] || [],
        }));
      } catch (error: any) {}
    } else {
      return;
    }
  };

  //#endregion

  //#region useMemo
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: { onFocusedRowChanged },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
      },
    }),
    [columns, dataSources]
  );
  //#endregion

  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            events={grids.grid1.events}
            etcProps={{
              rowSelection: "single",
              title: "",
            }}
            // filter={{
            //   refs: [gridRefs.current["grid2"]],
            //   columns: LINK_COLUMNS,
            // }}
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={grids.grid2.columns}
            rowData={grids.grid2.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "",
            }}
          />
        </SnResizeBar>
      </div>
    </div>
  );
  //#endregion
});

export default SN_MTL_QIO_REP_006;
